import React from 'react';
import { ScheduleProps } from '../index';
import { MatchTalkMessageOptionDto } from '@domain/rs/match/message/MatchingMessageListRs';

import classnames from 'classnames/bind';
import styles from './decidedSchedules.module.scss';
const cx = classnames.bind(styles);

interface DecidedSchedulesProps {
  interviewSn: string | null;
  decision?: MatchTalkMessageOptionDto;
  options: ScheduleProps[];
}

const DecidedSchedules = ({ interviewSn, decision, options }: DecidedSchedulesProps) => {
  const optionsEl = options.map((option) => {
    const isChecked = interviewSn === option.sn;
    const isAccept = decision?.command === 'ACCEPT' && option.sn === decision?.sn;

    return (
      <div key={option.sn} className={cx('labelWrap')}>
        <label className={cx('label', { confirm: isAccept }, 'disabled')}>
          <input type="checkbox" className={cx('input', 'hidden')} checked={isChecked} disabled={true} />
          <span className={cx('mark')} />
          {option.title}
        </label>
      </div>
    );
  });

  return (
    <div className={cx('scheduleArea')}>
      <span className={cx('info')}>면접 시간</span>
      {optionsEl}
    </div>
  );
};

export default DecidedSchedules;
